// --------------------------------------------------------------
// Created On: 2021-05-14
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./EllipsisSpinner.module.scss";

// Centered ellipsis spinner that lets the user know something is loading.
export default function EllipsisSpinner(props: Props): Component {
  return props.loading ? (
    <div className={styles.spinnerContainer}>
      <div role="status" className={styles.spinner} />
    </div>
  ) : null;
}

interface Props {
  loading: boolean;
}
